import type { IxfWatchlistV1Fincen314FileKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const FINCEN_FILE_BASE_PATH = getResolvedPath('/clearing/compliance/fincen/file');

export const getFincenFilePath: EntityPathBuilder<IxfWatchlistV1Fincen314FileKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return FINCEN_FILE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fincen314FileId) {
        return undefined;
      }

      return getResolvedPath(`${FINCEN_FILE_BASE_PATH}/$fincen314FileId`, context.keys);
    }
  }
};

export function getFincenFileDetailPath(fincen314FileId: string | undefined) {
  if (!fincen314FileId) {
    return undefined;
  }

  return getFincenFilePath({ kind: 'detail', keys: { fincen314FileId } });
}
